(() => {
  const PHONE_DISPLAY = '(833) 760-7333';
  const PHONE_HREF = 'tel:+18337607333';

  function repairFooterContact() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    footer.querySelectorAll('.footer-block__text li').forEach((item) => {
      const text = item.textContent.replace(/\s+/g, ' ').trim();

      if (/^Email\s*:/i.test(text)) {
        const link = document.createElement('a');
        link.href = '/pages/contact';
        link.textContent = 'Contact us';
        item.replaceChildren(link);
      }

      if (/^Phone\s*:/i.test(text)) {
        const link = item.querySelector('a');
        if (link) {
          link.href = PHONE_HREF;
          link.textContent = PHONE_DISPLAY;
          link.removeAttribute('target');
          link.removeAttribute('rel');
          link.setAttribute('aria-label', `Call ${PHONE_DISPLAY}`);
        }
      }
    });
  }

  function initialize() {
    repairFooterContact();
    window.setTimeout(repairFooterContact, 250);
    window.setTimeout(repairFooterContact, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('load', repairFooterContact, { once: true });
})();
